import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import cardsImg from '../images/cards.png';

import { motion } from "framer-motion";

const Home = () => {

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
        >
            <div style={{ paddingLeft: '7.5%', paddingRight: '7.5%', maxWidth: '50em', margin:'auto'}}>
                <div style={{marginTop: '10%'}}>
                    <Typography variant="h4">
                        Culture Cards
                    </Typography>
                </div>

                <div style={{marginTop: '1.5em'}}>
                    <img src={cardsImg} alt={"cards"} style={{
                            maxHeight: '100px', maxWidth: '100px'
                        }}
                    />
                </div>

                <div style={{textAlign: 'center', marginTop: '1.5em'}}>
                    <Typography variant="subtitle1">
                    or, how to leave Spotify and Netflix recommendations behind for <b>Friends, Family, and Grandma</b>

                    </Typography>
                </div>

                <div style={{marginTop:'1.5em'}}>
                    <Box textAlign="center">
                        <Button
                            onClick={() => {window.location.href="https://docs.google.com/forms/d/e/1FAIpQLSdSt0kFgzavOwmVX2uqEnskDk6ZodmWKAjrJPNGNQMsHNHbiA/viewform"}}
                            variant="contained"
                        >
                            Write recommendations
                        </Button>
                    </Box>
                </div>

                <Box mt='3em'>
                    <Divider style={{margin: '1em'}}/>
                    <Typography textAlign="left" variant="h6">
                        About this project
                    </Typography>
                    <Typography textAlign="left" variant="body1">
                    Culture Cards is the name of a new project by <a href="https://benma.dev">Ben Ma</a> to foster cross-cultural dialogue between friends and family, through culture, the arts, and entertainment: music, film, books, TV, videos, podcasts, and games.
                    This is a pre-alpha prototype, <i>the very first one</i>, and it's rough around the edges. Have fun and let me know what would make the experience better.
                    </Typography>
                </Box>
            </div>
        </motion.div>
    );
};

export default Home;